'use strict';

var ajv = require('./ajv.cjs.js');

function entityKindSchemaValidator(schema) {
  const validate = ajv.compileAjvSchema(schema);
  return (data) => {
    const result = validate(data);
    if (result === true) {
      return data;
    }
    const softCandidates = validate.errors?.filter(
      (e) => ["/kind", "/apiVersion"].includes(e.instancePath)
    );
    if (softCandidates?.length && softCandidates.every((e) => e.keyword === "enum")) {
      return false;
    }
    throw ajv.throwAjvError(validate.errors);
  };
}

exports.entityKindSchemaValidator = entityKindSchemaValidator;
//# sourceMappingURL=entityKindSchemaValidator.cjs.js.map
